<script lang="ts">
  import AutoComplete from '$shared/atoms/AutoComplete/AutoComplete.svelte';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { onMount } from 'svelte';

  interface Props {
    alert: DataListAlert;
    onevent?: (payload: { type: string; data: any }) => void;
  }

  let { alert, onevent }: Props = $props();

  let taxonomyId: string | undefined;
  let specialtyLabel: string | undefined = $state();

  onMount(() => {
    taxonomyId = alert?.props?.taxonomyId;
    specialtyLabel = alert.props?.list?.find((item: any) => item.id === taxonomyId)?.label || '';
  });

  const onClickSpecialty = (detail: CommonList): void => {
    taxonomyId = detail.id;
    specialtyLabel = detail.label;
    onevent?.({
      type: 'change-specialty',
      data: { key: alert.key, type: detail.id }
    });
  };

  const onSpecialtyInputCleared = (): void => {
    if (!taxonomyId) return;
    taxonomyId = '';
    specialtyLabel = '';
    onevent?.({ type: 'clear-specialty', data: { key: alert.key } });
  };
</script>

<AlertView type={ListAlertType.SpecialtyChange} key={Label.ChangeTo} icon="icon-corner-down-right">
  {#snippet value()}
    <div class="specialty">
      <AutoComplete
        name="specialty"
        list={alert.props?.list || []}
        placeholder="Search Specialty"
        value={specialtyLabel}
        onclick={onClickSpecialty}
        oncleared={onSpecialtyInputCleared}
      />
    </div>
  {/snippet}
</AlertView>

<style>
  .specialty {
    width: 400px;
    padding: 4px 16px;
  }
</style>
